<template>
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>Flag / Region / Vietnam</title>
    <defs>
      <circle id="path-1" cx="12" cy="12" r="12"></circle>
      <polygon
        id="path-3"
        points="3.17681818e-12 0 24 0 24 24 3.17681818e-12 24"
      ></polygon>
    </defs>
    <g
      id="Flag-/-Region-/-Vietnam"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <mask id="mask-2" fill="white">
        <use xlink:href="#path-1"></use>
      </mask>
      <g id="Mask" fill-rule="nonzero"></g>
      <g id="vn" mask="url(#mask-2)">
        <mask id="mask-4" fill="white">
          <use xlink:href="#path-3"></use>
        </mask>
        <g id="Path"></g>
        <g id="Group" mask="url(#mask-4)">
          <g transform="translate(-0.324401, 0.000000)" id="Path">
            <polygon
              fill="#EC0015"
              points="0.324400564 0 24.3244006 0 24.3244006 24 0.324400564 24"
            ></polygon>
            <polygon
              fill="#FFFF00"
              points="14.9386264 16.726407 11.9060026 14.4617218 8.89049852 16.748418 10.0130584 13.0310082 7 10.7369751 10.7271924 10.7051814 11.881546 7 13.0628018 10.6978444 16.7899943 10.7027358 13.7940555 13.0187799"
            ></polygon>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style>
</style>